import { z } from "zod";

/**
 * The round lifecycle:
 *
 *   collecting --(count >= threshold)--> pattern --(durationMs elapsed)--> completed
 *       ^                                                                     |
 *       +------------------ POST /api/admin/reset --------------------------- +
 *
 * `completed` holds the final image indefinitely: the installation is reset by an
 * admin, never automatically.
 */
export const stageStateSchema = z.discriminatedUnion("name", [
  z.object({ name: z.literal("collecting") }),
  z.object({
    name: z.literal("pattern"),
    /**
     * Epoch ms (server clock) the animation began. A client that connects mid-pattern
     * seeks to (serverNow - startedAt) instead of replaying from zero.
     */
    startedAt: z.number().int(),
    durationMs: z.number().int(),
  }),
  z.object({ name: z.literal("completed"), completedAt: z.number().int() }),
]);
export type StageState = z.infer<typeof stageStateSchema>;
export type StageName = StageState["name"];

/** Particles may only be released while collecting. */
export function isRoundOpen(stage: StageState): boolean {
  return stage.name === "collecting";
}
